export default __webpack_public_path__ + "static/media/balanced-preset.4297f0a4.svg";